import Axios from "axios";
import React, { useState } from "react";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import { API_URL, PLATFORM } from "../../../config";
import Control from "../../common/Control";
import Loader from "../../common/Loader";
import SaveBtn from "../../common/SaveBtn";

var recaptcha;

const ForgotPassword = ({ setForgotPassword, captchaToken }) => {
  const [email, setEmail] = useState("");
  const [emailOk, setEmailOk] = useState(false);
  const [errors, setErrors] = useState({});
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  function checkEmail(recaptchaToken) {
    Axios.post(API_URL + "auth/renew-password/" + PLATFORM, {
      login: email,
      captchaToken: recaptchaToken,
    })
      .then((res) => {
        setCheckingEmail(false);
        setEmailSent(true);
      })
      .catch((err) => {
        setCheckingEmail(false);

        if (err.response && err.response.data) {
          setErrors(err.response.data);
        }
      });
  }

  const validateForm = (e) => {
    e.preventDefault();
    setCheckingEmail(true);
  };

  const verifyCallback = (recaptchaToken) => {
    // Here you will get the final recaptchaToken!!!
    checkEmail(recaptchaToken);
  };

  return (
    <form
      onSubmit={validateForm}
      className="d-flex align-items-center justify-content-start flex-column mx-auto animated fadeInUp faster login-form mt-5"
    >
      <div className=" text-center">
        <div className="mb-5">
          <img src="/images/logo.svg" />
        </div>
        <h1 className="my-5 pt-5 pb-4 text-secondary main-title">
          J'ai oublié mon mot de passe
          <hr className="w-50 mt-4" />
        </h1>
      </div>
      {emailSent ? (
        <div>
          <p className="text-secondary mb-0 w-75 m-auto text-center">
            Un email vous a été envoyé pour réinitialiser votre mot de passe.
            Consultez votre boite email et cilquez sur le lien qu'il contient.
          </p>
          <button
            onClick={() => setForgotPassword(false)}
            className="btn btn-link w-100 mt-3"
          >
            <i className="fa fa-chevron-left mr-2"></i>Revenir à la connexion
          </button>
        </div>
      ) : (
        <>
          <p className="mb-4 w-75 text-left">
            Une fois ce formulaire rempli, vous recevrez un email contenant un
            lien qui vous permettra de définir un nouveau mot de passe pour
            votre compte.
          </p>
          <Control
            label="Entrez votre email"
            className="w-75"
            value={email}
            change={(e) => setEmail(e.target.value)}
            name="email"
            error={{ email: errors.login }}
          />
          {checkingEmail ? (
            <Loader className="my-3" withContainer={true} />
          ) : (
            <>
              <div className="w-75 mx-auto d-flex justify-content-end">
                {
                  <SaveBtn
                    className="animated zoomIn"
                    isSaving={checkingEmail}
                    save={checkEmail}
                    text="Recevoir le lien"
                    type="primary"
                    typeBtn="submit"
                  />
                }
              </div>
              <div className="w-75 mx-auto d-flex justify-content-start mt-2">
                <button
                  onClick={() => setForgotPassword(false)}
                  style={{ fontSize: 12 }}
                  className="btn btn-link text-secondary p-0"
                >
                  <i className="fa fa-chevron-left mr-2" />
                  Revenir à la connexion
                </button>
              </div>
            </>
          )}
        </>
      )}
      {checkingEmail && <GoogleReCaptcha onVerify={verifyCallback} />}
    </form>
  );
};

export default ForgotPassword;
